/* Mariesse ürün sayfası: ebat dropdown'ına fiyat, taksit güncelleme, teslimat çizelgesi */
(function () {
  'use strict';

  var dataEl = document.querySelector('[data-m-varyantlar]');
  var varyantlar = [];
  var tekSecenek = false;
  if (dataEl) {
    try { varyantlar = JSON.parse(dataEl.textContent); } catch (e) { varyantlar = []; }
    tekSecenek = dataEl.dataset.mSecenekSayisi === '1';
  }

  /* Dropdown seçeneklerinin yanına fiyatı yaz — tek ve çok seçenekli ürünlerde.
     Varyant anahtarı DOM sırasına göre kurulur ("Renk / Ebat"); renk swatch'ı
     değişince fiyatlar yeniden hesaplanır. */
  function fiyatEkle() {
    if (!varyantlar.length) return;
    var gruplar = Array.prototype.slice.call(document.querySelectorAll('variant-selects .product-form__input'));

    gruplar.forEach(function (grup, idx) {
      var sel = grup.querySelector('select');
      if (!sel) return;
      Array.prototype.forEach.call(sel.options, function (opt) {
        var parcalar = [];
        for (var i = 0; i < gruplar.length; i++) {
          if (i === idx) { parcalar.push(opt.value); continue; }
          var digerSel = gruplar[i].querySelector('select');
          if (digerSel) { parcalar.push(digerSel.value); continue; }
          var isaretli = gruplar[i].querySelector('input:checked');
          if (!isaretli) return;
          parcalar.push(isaretli.value);
        }
        var anahtar = parcalar.join(' / ');
        for (var k = 0; k < varyantlar.length; k++) {
          if (varyantlar[k].t !== anahtar) continue;
          // opt.value orijinal ad — her seferinde sıfırdan kurulur, tekrar eklenmez
          opt.textContent = opt.value + '  —  ' + (varyantlar[k].a ? varyantlar[k].p : 'Tükendi');
          return;
        }
      });
    });
  }

  /* Seçili varyanta göre aylık taksit tutarını güncelle */
  function taksitGuncelle() {
    var hedef = document.querySelector('[data-m-taksit-tutar]');
    if (!hedef || !varyantlar.length) return;
    // Seçenekleri DOM sırasında topla — swatch (fieldset) ve dropdown karışık olduğunda
    // varyant başlığı "Renk / Ebat" sırasını korumalı, yoksa eşleşme tutmaz.
    var secimler = [];
    document.querySelectorAll('variant-selects .product-form__input').forEach(function (g) {
      var sel = g.querySelector('select');
      if (sel) { secimler.push(sel.value); return; }
      var c = g.querySelector('input:checked');
      if (c) secimler.push(c.value);
    });
    if (!secimler.length) return;
    var anahtar = secimler.join(' / ');
    for (var i = 0; i < varyantlar.length; i++) {
      if (varyantlar[i].t === anahtar) { hedef.textContent = varyantlar[i].t3; return; }
    }
  }

  fiyatEkle();
  taksitGuncelle();
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) {
      taksitGuncelle();
      setTimeout(fiyatEkle, 400);
    }
  });

  /* Teslimat çizelgesi: kesim saati + pazar atlamalı iş günü hesabı */
  var kutu = document.querySelector('[data-m-teslimat]');
  if (kutu) {
    var aylar = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    var kesim = parseInt(kutu.dataset.mKesim, 10) || 15;
    var minGun = parseInt(kutu.dataset.mMin, 10) || 1;
    var maxGun = parseInt(kutu.dataset.mMax, 10) || 3;

    function isGunuEkle(tarih, adet) {
      var t = new Date(tarih);
      while (adet > 0) {
        t.setDate(t.getDate() + 1);
        if (t.getDay() !== 0) adet--;
      }
      return t;
    }
    function bicimle(t) { return t.getDate() + ' ' + aylar[t.getMonth()]; }

    function teslimatGuncelle() {
      var simdi = new Date();
      var bugunKargoda = simdi.getDay() !== 0 && simdi.getHours() < kesim;
      var kargoTarihi = bugunKargoda ? new Date(simdi) : isGunuEkle(simdi, 1);
      var teslimMin = isGunuEkle(kargoTarihi, minGun);
      var teslimMax = isGunuEkle(kargoTarihi, maxGun);

      var mesaj = kutu.querySelector('[data-m-teslimat-mesaj]');
      if (mesaj) {
        if (bugunKargoda) {
          var son = new Date(simdi);
          son.setHours(kesim, 0, 0, 0);
          var fark = son - simdi;
          var sa = Math.floor(fark / 3600000);
          var dk = Math.floor((fark % 3600000) / 60000);
          var sayac = sa > 0 ? sa + ' sa ' + dk + ' dk' : dk + ' dk';
          mesaj.innerHTML = '<strong>' + sayac + '</strong> içinde sipariş verin, <strong>bugün kargoda</strong>';
        } else {
          mesaj.innerHTML = 'Şimdi sipariş verin, <strong>' + bicimle(kargoTarihi) + '</strong> günü kargoda';
        }
      }
      var kargoEl = kutu.querySelector('[data-m-kargo-tarih]');
      if (kargoEl) kargoEl.textContent = bugunKargoda ? 'Bugün' : bicimle(kargoTarihi);
      var teslimEl = kutu.querySelector('[data-m-teslim-tarih]');
      if (teslimEl) teslimEl.textContent = bicimle(teslimMin) + ' – ' + bicimle(teslimMax);
    }

    teslimatGuncelle();
    setInterval(teslimatGuncelle, 30000);
  }
})();

// Galeri okları: masaüstünde ana görselin iki yanında önceki/sonraki
(function () {
  var galeri = document.querySelector("media-gallery[data-desktop-layout='thumbnail_slider']");
  if (!galeri) return;
  var izleyici = galeri.querySelector('slider-component:not(.thumbnail-slider)');
  var kucukler = galeri.querySelectorAll('.thumbnail-list__item');
  if (!izleyici || kucukler.length < 2) return;

  function atla(adim) {
    // Renk filtresiyle gizlenen küçük resimleri atla
    var liste = Array.prototype.slice.call(galeri.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
      return !li.classList.contains('m-medya-gizli');
    });
    if (!liste.length) return;
    var aktif = galeri.querySelector('.product__media-item.is-active');
    var aktifId = aktif ? aktif.getAttribute('data-media-id') : null;
    var indeks = -1;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].getAttribute('data-target') === aktifId) { indeks = i; break; }
    }
    var yeni = (indeks + adim + liste.length) % liste.length;
    var dugme = liste[yeni].querySelector('.thumbnail');
    if (dugme) dugme.click();
  }

  function olustur(yon, etiket, yol) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'm-galeri-ok m-galeri-ok--' + yon;
    b.setAttribute('aria-label', etiket);
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + yol + '"/></svg>';
    b.addEventListener('click', function () { atla(yon === 'ileri' ? 1 : -1); });
    return b;
  }

  var ul = izleyici.querySelector('.product__media-list');
  if (!ul) return;
  izleyici.insertBefore(olustur('geri', 'Önceki görsel', 'M15 5l-7 7 7 7'), ul);
  izleyici.appendChild(olustur('ileri', 'Sonraki görsel', 'M9 5l7 7-7 7'));
})();

/* ---------- Galeri renk filtresi: sadece seçili rengin görselleri ----------
   Medya alt metinleri "Ürün adı — Renk" biçiminde etiketli; Liquid bunu
   li[data-m-renk] olarak basar. Seçili renk (fotoğraflı swatch) değişince
   diğer renklerin görselleri gizlenir. Etiketsiz (paylaşılan) medya hep görünür;
   seçili renge ait hiç görsel yoksa filtre uygulanmaz (tam galeri). */
(function () {
  var galeri = document.querySelector('media-gallery');
  if (!galeri) return;
  var etiketli = galeri.querySelectorAll('[data-m-renk]');
  if (!etiketli.length) return;

  function seciliRenk() {
    var giris = document.querySelector('variant-selects .m-swatch-alan input:checked');
    return giris ? giris.value.trim() : null;
  }

  function uygula() {
    var renk = seciliRenk();
    var ogeler = galeri.querySelectorAll('.product__media-item, .thumbnail-list__item');
    var eslesen = 0;
    if (renk) {
      ogeler.forEach(function (li) {
        var r = li.getAttribute('data-m-renk');
        if (r && r === renk) eslesen++;
      });
    }
    var filtrele = !!renk && eslesen > 0;
    ogeler.forEach(function (li) {
      var r = li.getAttribute('data-m-renk');
      var gizle = filtrele && r && r !== renk;
      li.classList.toggle('m-medya-gizli', gizle);
    });

    // Aktif görsel gizlendiyse seçili rengin ilk görünen küçük resmine geç
    var aktif = galeri.querySelector('.product__media-item.is-active');
    if (aktif && aktif.classList.contains('m-medya-gizli')) {
      var ilk = galeri.querySelector('.thumbnail-list__item:not(.m-medya-gizli) .thumbnail');
      if (ilk) ilk.click();
    }
    // Dawn kaydırıcıları sayfa/sayaç bilgisini yeniden hesaplasın
    galeri.querySelectorAll('slider-component').forEach(function (s) {
      if (typeof s.resetPages === 'function') s.resetPages();
      if (typeof s.update === 'function') s.update(); // "1 / 6" sayacı hemen tazelensin
    });
  }

  uygula();
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) setTimeout(uygula, 60);
  });
  // Dawn varyant değişiminde galeriyi yeniden basarsa tekrar uygula
  new MutationObserver(function () { setTimeout(uygula, 0); }).observe(galeri, { childList: true });
})();

/* ---------- Mobil sabit satın alma barı ---------- */
(function () {
  function barKur() {
    var bar = document.querySelector('[data-m-sabit-bar]');
    if (!bar || bar.dataset.mKurulu === '1') return;
    var anaBtn = document.querySelector('.product__info-container .product-form__submit');
    if (!anaBtn) return;
    bar.dataset.mKurulu = '1';

    var gorunur = false;
    function ayarla(goster) {
      if (goster === gorunur) return;
      gorunur = goster;
      bar.classList.toggle('gorunur', goster);
      bar.setAttribute('aria-hidden', goster ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      // Ana buton ekrandan çıktığında barı göster
      new IntersectionObserver(function (girisler) {
        girisler.forEach(function (g) { ayarla(!g.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(anaBtn);
    } else {
      window.addEventListener('scroll', function () {
        ayarla(anaBtn.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  }

  barKur();
  // Varyant değişiminde Dawn bölümü yeniden basıyor; barı tekrar bağla.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) setTimeout(barKur, 500);
  });
})();
